class Accordion {
  constructor($el) {
    this.$el = $el;
    this.$btn = this.$el.find('.AccordionBtn');
    this.$content = this.$el.find('.Accordion__content');
    this.$heightObject = this.$el.find('.Accordion__height');
    this.isOpen = false;

    this.$btn.on('click', () => {
      // console.log('click');
      if(this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  open() {
    if(!this.isOpen) {
      this.isOpen = true;

      this.$el.addClass('Accordion--open');

      this.$content
        .stop(false)
        .animate({'height': this.$heightObject.height()}, 1000, 'easeInOutExpo', () => {
          this.$content.css({
            'overflow': 'visible',
            'height': 'auto'
          });
        });
    }
  }

  close() {
    if(this.isOpen) {
      this.isOpen = false;

      this.$el.removeClass('Accordion--open');

      this.$content
        .stop(false)
        .css({'height': this.$heightObject.height(), 'overflow-y': 'hidden'})
        .animate({'height': 1}, 400);
    }
  }
}

export default Accordion;
